import React, { useState } from 'react';
import { X } from 'lucide-react';

export const PhotoGalleryModal = ({ images, assetName, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[hsl(var(--border))]">
          <h3 className="text-xl font-bold text-[hsl(var(--text-primary))]">
            {assetName} - Photos
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-[hsl(var(--background-secondary))] rounded-lg transition-colors duration-200"
          >
            <X className="w-5 h-5 text-[hsl(var(--text-secondary))]" />
          </button>
        </div>

        {/* Gallery */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {images && images.length > 0 ? (
              images.map((img, index) => (
                <div key={index} className="rounded-lg overflow-hidden">
                  <img
                    src={img}
                    alt={`${assetName} - Photo ${index + 1}`}
                    className="w-full h-64 object-cover"
                  />
                </div>
              ))
            ) : (
              <div className="col-span-2 text-center py-12 text-[hsl(var(--text-secondary))]">
                No photos available
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
